module.exports = __webpack_public_path__ + "img/btn_g.ee394053.webp";